import React from 'react';
import { Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BreakfastColors, BreakfastConstants } from '../../theme/BreakfastTheme';

interface BreakfastCardProps {
  children: React.ReactNode;
  backgroundColor?: string;
  borderColor?: string;
  padding?: number | string;
}

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) =>
    prop !== 'customBackgroundColor' &&
    prop !== 'customBorderColor' &&
    prop !== 'customPadding',
})<{
  customBackgroundColor?: string;
  customBorderColor?: string;
  customPadding?: number | string;
}>(({ customBackgroundColor, customBorderColor, customPadding }) => ({
  backgroundColor: customBackgroundColor || BreakfastColors.defaultFill,
  borderRadius: BreakfastConstants.cornerRadius,
  border: customBorderColor ? `1px solid ${customBorderColor}` : 'none',
  boxShadow: 'none',
  '& .MuiCardContent-root': {
    padding: customPadding || BreakfastConstants.cardPadding,
    '&:last-child': {
      paddingBottom: customPadding || BreakfastConstants.cardPadding,
    },
  },
}));

export const BreakfastCard: React.FC<BreakfastCardProps> = ({
  children,
  backgroundColor,
  borderColor,
  padding,
}) => {
  return (
    <StyledCard
      customBackgroundColor={backgroundColor}
      customBorderColor={borderColor}
      customPadding={padding}
    >
      <CardContent>
        {children}
      </CardContent>
    </StyledCard>
  );
};
